import Swal from "sweetalert2";
import { config } from "../CommonUrl/CommonUrls";
import * as jnb from "react-bootstrap";



export function viewImage(fileName) {
  let url = config.url.FILE_DOWNLOAD_URL + fileName;
  const dataType = fileName?.split(".")[1];
  if (dataType === "pdf") {
    showPDF(url)
    // downloadPDF(url);
  } else if (dataType === "text") {
    const newTab = window.open();
    newTab.document.body.innerHTML = `<embed src="${url}" width="100%" height="100%" ></embed>`;
  } else {
    const swalPopup = Swal.fire({
      html: `<img src="${url}" class="img-thumbnail" />`,
      width: "80%",
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        content: "custom-modal-content",
      },
    });
    window.addEventListener("popstate", () => {
      swalPopup.close();
    });
  }
}
export function viewBucketImage(fileName, VAL) {
  let url = config.url.FILE_DOWNLOAD_URL + fileName;
  const dataType = fileName.split(".")[1];

  if (dataType === "pdf") {
    return (
      <div className="">
        <jnb.Modal
          size="xl"
          show={VAL}
          className="mt-5"
          backdrop="static"
          id="modalataddparticipant"
        >
          <jnb.Modal.Header>
            <jnb.Modal.Title>
              <h5>Generate Sanctioned Order</h5>
            </jnb.Modal.Title>
            <button type="button" className="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </jnb.Modal.Header>
          <jnb.Modal.Body>
            <div className="jumbotro mt20 form-card-jnb border mt-0">
              <embed
                src={url}
                className="pdf-embed"
                width="100%"
                height="100%"
                type="application/pdf"
              />
            </div>
          </jnb.Modal.Body>
        </jnb.Modal>
      </div>
    );
  } else if (dataType === "text") {
    const newTab = window.open();
    newTab.document.body.innerHTML = `<iframe src="${url}" width="100%" height="100%" ></iframe>`;
  } else {
    const swalPopup = Swal.fire({
      html: `<img src="${url}" class="img-thumbnail" />`,
      width: "80%",
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        content: "custom-modal-content",
      },
    });
    window.addEventListener("popstate", () => {
      swalPopup.close();
    });
  }
}

// utils/downloadPDF.js
export const downloadPDF = async (fileName, setLoading) => {

   let imgg = config.url.FILE_DOWNLOAD_URL + fileName;
   
  if (!imgg || typeof imgg !== "string") {
    console.error("Invalid file URL:", imgg);
    return;
  }

  try {
    setLoading?.(true); // only call if setLoading is passed

    const response = await fetch(imgg);
    if (!response.ok) throw new Error("File not found or not accessible");

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = imgg.split("/").pop() || "download.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
  } finally {
    setLoading?.(false);
  }
};


export const ViewBucketImage = ({ url }) => {
  let setShowModal = true;
  const closeModal = () => {
    setShowModal = false;
  };
  return (
    <div className="">
      <jnb.Modal
        size="xl"
        show={setShowModal}
        className="mt-5"
        backdrop="static"
        id="modalataddparticipant"
      >
        <jnb.Modal.Header>
          <jnb.Modal.Title>
            <h5>Generate Sanctioned Order</h5>
          </jnb.Modal.Title>
          <button
            type="button"
            onClick={closeModal}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </jnb.Modal.Header>
        <jnb.Modal.Body>
          <div className="jumbotro mt20 form-card-jnb border mt-0">
            <embed
              src={url}
              className="pdf-embed"
              width="100%"
              height="100%"
              type="application/pdf"
            />
          </div>
        </jnb.Modal.Body>
      </jnb.Modal>
    </div>
  );
};

const showPDF = (imgg) =>
  ConvertFileToBase64(imgg)
    .then((base64Data) => {
      const extractedData = base64Data.split(",")[1];
      const binaryData = atob(extractedData);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
async function ConvertFileToBase64(fileUrl) {
  const response = await fetch(fileUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
